<script>
  import { onMount } from "svelte";

  // Function to load Font Awesome icons
  function loadFontAwesome() {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css";
    document.head.appendChild(link);
  }

  function showText(index) {
    const cardTexts = document.querySelectorAll(".card-text");
    cardTexts[index].classList.add("show");
  }

  function hideText(index) {
    const cardTexts = document.querySelectorAll(".card-text");
    cardTexts[index].classList.remove("show");
  }

  onMount(loadFontAwesome);
  let testimonialIndex = 0;
  const testimonials = [
    {
      quote:
        "Amazing experience working with this company. Their team is incredibly talented and dedicated.",
      author: "John Smith, CEO at ABC Company",
    },
    {
      quote:
        "I've been consistently impressed with the quality of service provided by this company. Highly recommended!",
      author: "Emily Johnson, Marketing Manager",
    },
    // Add more testimonials as needed
  ];

  function goToPrevTestimonial() {
    testimonialIndex =
      (testimonialIndex - 1 + testimonials.length) % testimonials.length;
  }

  function goToNextTestimonial() {
    testimonialIndex = (testimonialIndex + 1) % testimonials.length;
  }

  let currentIndex = 0;

  function goToNext() {
    currentIndex = (currentIndex + 1) % (galleryItems.length - 2);
  }

  function goToPrevious() {
    currentIndex =
      (currentIndex - 1 + galleryItems.length - 2) % (galleryItems.length - 2);
  }

  const galleryItems = [
    { src: "/img/im1.png", alt: "Image 1", caption: "Analytics App" },
    { src: "/img/im2.png", alt: "Image 2", caption: "Marketing Tools" },
    { src: "/img/im3.png", alt: "Image 3", caption: "Chat Bot" },
    { src: "/img/im4.png", alt: "Image 4", caption: "Data Visualization" },
    { src: "/img/im5.png", alt: "Image 5", caption: "SEO Optimization" },
    { src: "/img/im1.png", alt: "Image 6", caption: "Customer Support" },
    // Add more gallery items as needed
  ];
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://unpkg.com/mono-icons@1.2.1/iconfont/icons.css"
  />
</svelte:head>

<div class="pagewrap">
  <div class="container">
    <img src="/img/home.png" alt="Background Image" class="full-width" />
    <div class="contenthod">
      <h1>
        <span class="first-span">Mobile app</span><br />
        <span class="second-span">development for</span><br />
        <span class="violet">funded companies.</span><br />
      </h1>
      <p>
        <span class="small"
          >Helping companies succeed through customized <br />software solutions</span
        >
      </p>
      <button class="btn">Discover More</button>
    </div>
  </div>
</div>

<div class="card-container1">
  <div
    class="card1"
    on:mouseenter={() => showText(0)}
    on:mouseleave={() => hideText(0)}
  >
    <i class="fas fa-globe"></i>
    <!-- Replace with appropriate icon -->
    <h3>Global Synergy</h3>
    <p>
      Worldwide collabs forging international partnerships and interconnected
      alliances.
    </p>
    <button class="card-btn1">Learn More</button>
    <div class="card-text">Global Synergy</div>
  </div>

  <div
    class="card1"
    on:mouseenter={() => showText(1)}
    on:mouseleave={() => hideText(1)}
  >
    <i class="fas fa-lightbulb"></i>
    <!-- Replace with appropriate icon -->
    <h3>Innovation Hub</h3>
    <p>
      Creative epicenter fostering inventive breakthroughs and transformative
      advancements.
    </p>
    <button class="card-btn1">Explore</button>
    <div class="card-text">Innovation Hub</div>
  </div>

  <div
    class="card1"
    on:mouseenter={() => showText(2)}
    on:mouseleave={() => hideText(2)}
  >
    <i class="fas fa-brain"></i>
    <!-- Replace with appropriate icon -->
    <h3>Digital Wisdom</h3>
    <p>
      Tech expertise showcased with insightful knowledge and cutting-edge
      solutions.
    </p>
    <button class="card-btn1">Try Now</button>
    <div class="card-text">Digital Wisdom</div>
  </div>
</div>

<div class="image-grid" style="padding-bottom: 50px;">
  <div class="image-description">
    <h2>Discover a suite of development services tailored for success</h2>
    <!-- Add your text here -->
    <p>
      from mobile app and software solutions to web development, blockchain, and
      captivating games. At Dynamic Eye, innovation meets precision, delivering
      user-centric designs and agile solutions that adapt to your evolving
      needs. Elevate your digital presence with us, where brilliance is crafted,
      and excellence is the standard.
    </p>
  </div>
  <div
    class="image-container"
    on:mouseenter={() => showText(3)}
    on:mouseleave={() => hideText(3)}
  >
    <img src="/img/im1.png" alt="Image 1" class="card-image" />
    <div class="card-text">Blockchain</div>
  </div>

  <div
    class="image-container"
    on:mouseenter={() => showText(4)}
    on:mouseleave={() => hideText(4)}
  >
    <img src="/img/im2.png" alt="Image 2" class="card-image" />
    <div class="card-text">Software</div>
  </div>

  <div
    class="image-container"
    on:mouseenter={() => showText(5)}
    on:mouseleave={() => hideText(5)}
  >
    <img src="/img/im3.png" alt="Image 3" class="card-image" />
    <div class="card-text">Web Service</div>
  </div>

  <div
    class="image-container"
    on:mouseenter={() => showText(6)}
    on:mouseleave={() => hideText(6)}
  >
    <img src="/img/im4.png" alt="Image 4" class="card-image" />
    <div class="card-text">Mobile App</div>
  </div>

  <div
    class="image-container"
    on:mouseenter={() => showText(7)}
    on:mouseleave={() => hideText(7)}
  >
    <img src="/img/im5.png" alt="Image 5" class="card-image" />
    <div class="card-text">Game Service</div>
  </div>
</div>

<div class="job-section">
  <div class="job-content">
    <h2>Join Our Team</h2>
    <p>
      Discover exciting career opportunities with us. We value creativity,
      innovation, and dedication. Join a team that fosters growth and learning.
    </p>
    <button class="job-btn">Apply Now</button>
  </div>
</div>

<div class="gallery-section" style="padding-bottom: 50px;">
  <div class="gallery-description">
    <h2>Portfolio Showcase</h2>
    <p>
      Explore our portfolio showcase to witness the culmination of our expertise
      and creativity. Each item exemplifies our commitment to excellence and
      innovation. Click on any project to delve deeper into its details and
      discover the quality of our work firsthand.
    </p>
  </div>
  <div class="gallery-container">
    {#each galleryItems.slice(currentIndex, currentIndex + 3) as item, index}
      <div class="gallery-item">
        <img src={item.src} alt={item.alt} class="gallery-image" />
        <div class="gallery-caption">{item.caption}</div>
      </div>
    {/each}
  </div>
  <div class="arrow-icons">
    <button class="arrow-button1" on:click={goToPrevious}>
      <i class="mi mi-arrow-left"></i>
    </button>
    <button class="arrow-button1" on:click={goToNext}>
      <i class="mi mi-arrow-right"></i>
    </button>
  </div>
</div>
<div
  class="testimonials-section"
  style="padding-top: 50px; padding-bottom: 50px;"
>
  <h3 class="clients-text">Hear from our happy clients.</h3>
  <button on:click={goToPrevTestimonial} class="arrow-button left">
    <i class="mi mi-arrow-left"></i>
  </button>
  <div class="testimonials-container">
    {#each testimonials as testimonial, index}
      <div
        class="testimonial"
        style="display: {index === testimonialIndex ? 'block' : 'none'};"
      >
        <p class="quote bigger">{testimonial.quote}</p>
        <p class="author bigger">{testimonial.author}</p>
      </div>
    {/each}
  </div>
  <button on:click={goToNextTestimonial} class="arrow-button right">
    <i class="mi mi-arrow-right"></i>
  </button>
</div>
<footer class="footer">
  <div class="footer-content">
    <div class="footer-section">
      <h4>Quick Links</h4>
      <ul>
        <li><a href="#">Home</a></li>
        <li><a href="#">Services</a></li>
        <li><a href="#">About Us</a></li>
        <li><a href="#">Contact Us</a></li>
        <li><a href="#">Careers</a></li>
      </ul>
    </div>
    <div class="footer-section">
      <h4>DEVELOPMENT</h4>
      <ul>
        <li><a href="#">Mobile App</a></li>
        <li><a href="#">Software</a></li>
        <li><a href="#">Game</a></li>
        <li><a href="#">Web</a></li>
        <li><a href="#">Blockchain</a></li>
      </ul>
    </div>
    <div class="newsletter-form">
      <form>
        <h2 style="color: #39e9e0; font-size: 1.8rem;">Craft2Code</h2>
        <p style="font-size: 1.2rem;">
          Subscribe for tech insights,<br /> innovation, and strategic brilliance
          delivered regularly.
        </p>
        <input
          type="email"
          placeholder="Enter your email"
          required
          style="padding: 15px; border: none; border-radius: 5px; flex: 1; margin-right: 10px; width: 100%;"
        />
        <button type="submit">Subscribe</button>
      </form>
    </div>
  </div>
  <div class="footer-bottom">
    <p>&copy; 2024 Your Company. All rights reserved.</p>
  </div>
</footer>

<style>
  /* Existing styles for the image and content */
  .first-span {
    margin-bottom: 10px; /* Reduce distance between the first and second spans */
  }

  .second-span {
    margin-bottom: 10px; /* Reduce distance between the second and third spans */
  }

  .container {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden; /* to prevent horizontal scrolling */
    position: relative; /* to make the content position relative to the container */
  }

  .full-width {
    width: 100%;
    height: auto; /* to maintain aspect ratio */
    object-fit: cover; /* to cover the entire container */
  }

  .contenthod {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    color: white;
    text-align: left;
    left: 15%;
    font-weight: bold;
    font-family: Century Gothic;
    font-size: 1.8rem;
    white-space: nowrap;
  }

  .blue {
    color: #054f76;
  }

  .violet {
    color: rgb(255, 255, 255); /* Add color for the third span */
  }

  .small {
    color: white; /* Set color of the paragraph text to white */
  }

  .btn {
    display: inline-block;
    margin-top: 20px;
    padding: 10px 20px;
    font-size: 18px;
    background-color: #191a1b;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .btn::before,
  .btn::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
    height: 100%;
    background-color: rgba(21, 117, 241, 0.5);
    transition: width 0.3s ease; /* Smooth transition animation */
    color: #333;
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .btn::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .btn::after {
    right: 50%;
    transform: translateX(50%);
  }

  .job-btn:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .btn:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  /* Additional styles for adjusting padding and font size */
  .btn {
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
  }

  .btn:hover {
    color: blue; /* Change text color on hover */
    background-color: #dddddd; /* Change background color on hover */
  }
  /* Styles for the card section */
  .card-container {
    display: flex;
    justify-content: space-around;
    margin-top: 40px;
  }
  .card-container1 {
    display: flex;
    justify-content: space-around;
    margin-top: 40px;
    padding-bottom: 30px;
  }

  .card1 {
    transition: background-color 2s ease-in-out;
    width: 25%; /* Adjusted width */
    height: 300px; /* Increased height */
    background-color: #f2f2f2;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .card1 i {
    font-size: 40px;
    margin-bottom: 10px;
  }
  .card1 h3 {
    margin-bottom: 10px;
  }
  .card1:hover {
    background-color: #39e9e0; /* Change to desired background color */
  }

  /* Animation for card1 hover */
  .card1:hover .card-btn1 {
    transform: translateY(7px);
    transition: transform 0.3s ease-in-out;
  }

  /* Animation for button */

  .card-btn1:hover {
    background-color: #35d4e9; /* Change to desired hover color */
  }

  .card1 p {
    font-size: 0.9rem;
    margin-bottom: 20px;
  }
  .card1 .card-btn1 {
    background-color: #054f76;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
  }

  .image-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: auto;
    gap: 20px;
  }

  .image-container {
    position: relative;
    overflow: hidden;
  }

  .card-image {
    width: 100%;
    height: 100%;
    display: block;
    transition: transform 0.3s ease;
  }

  .card-image:hover {
    transform: scale(1.1);
  }

  .card-text {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px;
    box-sizing: border-box;
    transform: translateY(100%);
    transition: transform 0.3s ease;
    opacity: 0;
  }

  .image-container:hover .card-text {
    transform: translateY(0);
    opacity: 1;
  }

  .card-text1 {
    position: absolute;
    bottom: 10px; /* Padding from the bottom */
    left: 10px; /* Padding from the left */
    font-size: 16px;
    font-weight: bold;
  }

  .card-btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
  }
  .job-section {
    background-color: #054f76;
    color: white;
    padding: 60px 20px;
    text-align: center;
  }

  .job-content {
    max-width: 800px;
    margin: 0 auto;
  }

  .job-content h2 {
    font-size: 2rem;
    margin-bottom: 20px;
  }

  .job-content p {
    font-size: 1.2rem;
    margin-bottom: 30px;
  }

  .job-btn {
    display: inline-block;
    padding: 10px 20px;
    font-size: 18px;
    background-color: #191a1b;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .job-btn::before,
  .job-btn::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
    height: 100%;
    background-color: rgba(21, 117, 241, 0.5);
    transition: width 0.3s ease; /* Smooth transition animation */
    color: #333;
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .job-btn::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .job-btn::after {
    right: 50%;
    transform: translateX(50%);
  }

  .job-btn:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .job-btn:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  /* Additional styles for adjusting padding and font size */
  .job-btn {
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
  }

  .job-btn:hover {
    color: blue; /* Change text color on hover */
    background-color: #dddddd; /* Change background color on hover */
  }
  .gallery-description {
    text-align: center;
    margin-bottom: 20px;
  }

  .gallery-description h2 {
    font-size: 2rem;
    margin-bottom: 10px;
    color: #054f76;
  }

  .gallery-description p {
    font-size: 1.2rem;
  }

  .gallery-section {
    background-color: #f9f9f9;
    padding: 40px 0;
  }

  .gallery-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .gallery-item {
    width: 200px;
    height: 260px; /* Adjusted height */
    margin: 20px;
    text-align: center;
    position: relative;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    transition: filter 0.3s ease;
  }

  .gallery-item:hover .gallery-image {
    filter: brightness(70%);
  }

  .gallery-caption {
    margin-top: 10px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    padding: 10px;
    border-radius: 10px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .gallery-item:hover .gallery-caption {
    opacity: 1;
  }
  .testimonials-section {
    position: relative;
    text-align: center;
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.5rem; /* Increase font size */
    margin-bottom: 20px;
  }
  .clients-text {
    color: #054f76;
    font-size: 1.5rem; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-weight: bold;
    font-size: 1.2rem; /* Increase font size */
    margin-bottom: 20px;
  }

  .arrow-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
  }

  .arrow-button.left {
    left: 10px;
  }

  .arrow-button.right {
    right: 10px;
  }

  .image-description {
    text-align: center;
    margin-bottom: 20px; /* Add some space between the text and the images */
  }

  .image-description h2 {
    font-size: 2rem;
    margin-bottom: 10px;
    color: #054f76;
  }

  .image-description p {
    font-size: 1rem;
  }
  .arrow-icons {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .arrow-button {
    background-color: blue;
    border: none;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px;
    border-radius: 50%;
  }

  .arrow-button i {
    font-size: 24px;
    color: white;
  }

  .arrow-button1 {
    background-color: blue;
    border: none;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px;
    border-radius: 50%;
  }

  .arrow-button1 i {
    font-size: 24px;
    color: white;
  }

  .arrow-button i {
    font-size: 24px;
    color: white;
  }
</style>
